import type {ReactElement} from 'react';
import {assertNever} from '@Utils/assert-never.util';
import {SkeletonBrick} from '@Components/skeleton-brick';
import type {PreviewAccountMetaSkeletonProps} from './preview-account-meta-skeleton.types';
import {PREVIEW_ACCOUNT_META_BAR_WIDTH, PREVIEW_ACCOUNT_META_PART_HEIGHT, PREVIEW_ACCOUNT_META_PART_RADIUS, PREVIEW_ACCOUNT_META_SQUARE_WIDTH, PreviewAccountMetaPart} from './preview-account-meta-skeleton.types';
import styles from './preview-account-meta-skeleton.module.scss';

export function PreviewAccountMetaSkeleton({parts}: PreviewAccountMetaSkeletonProps): ReactElement {
  const getPartWidth = (part: PreviewAccountMetaPart): number => {
    switch (part) {
      case PreviewAccountMetaPart.BAR:
        return PREVIEW_ACCOUNT_META_BAR_WIDTH;
      case PreviewAccountMetaPart.SQUARE:
        return PREVIEW_ACCOUNT_META_SQUARE_WIDTH;
      default:
        return assertNever(part);
    }
  };

  const getMetaParts = (): ReactElement[] => {
    return parts.map((part: PreviewAccountMetaPart): ReactElement => {
      return <SkeletonBrick key={part} width={getPartWidth(part)} height={PREVIEW_ACCOUNT_META_PART_HEIGHT} radius={PREVIEW_ACCOUNT_META_PART_RADIUS} />;
    });
  };

  return (
    <div className={styles.previewAccountMetaSkeleton} aria-hidden="true">
      {getMetaParts()}
    </div>
  );
}
